// extracted by mini-css-extract-plugin
module.exports = {"show_only_safe_device":"show-only-safe-device-show_only_safe_device__1Dym5"};